import Client from "../Client";
import Exceptions from "../Exceptions";
import { validateAccount } from "../misc/account";
import { wait } from "../misc/date";
import { listToCollection } from "../misc/object";
import { getParams } from "../misc/path";
import { MainRouter } from "../routes";
import { login, register } from "../services/api/account";
import { getLGUList, getProvinceList } from "../services/api/meta";
import { Notifier } from "./conductor";

class RegisterController {

    constructor() {
        this.notifiers = {
            ready: new Notifier(false),
            registering: new Notifier(false),
            error: new Notifier(),
            registered: new Notifier(false),
        };

        const self = this;

        this.status = {
            get ready() { return self.notifiers.ready.get() },
            get registering() { return self.notifiers.registering.get() },
            get error() { return self.notifiers.error.get() },
            get registered() { return self.notifiers.registered.get() },
        }
    }
    
    /** @type {{ error: string, status: "error" | "loggingIn", ready: boolean, registered: boolean }} */
    states = {};
    isInitialized = false;

    async initialize() {
        if(this.isInitialized) return;

        this.isInitialized = true;
        this.collection = {
            province: listToCollection(await getProvinceList()),
            lgu: listToCollection(await getLGUList())
        };

        console.log(this.collection);

        this.notifiers.ready.update(true);
    }

    async register(account) {
        const { error, registering, registered } = this.notifiers;

        const validated = validateAccount(account, true);
        if(!validated.ok) {
            error.update(validated.error);
            return;
        }

        registering.update(true);
        try {
            
            await register(validated.account);
            return registered.update(true);
            // Client.logAccount(result.data.account, result.data.token);
            // states.status = null;
            // const redirection = getParams()["redirect"];
            // if(redirection) MainRouter.goto(redirection);
            // else MainRouter.goto("/");
        } catch (e) {
            console.log(e);
            error.update(Exceptions.getARESemantics(e).message);
        }

        registering.update(false);
    }

    async goToLogin() {
        MainRouter.goto("/login");
    }
};

export default RegisterController;